import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["name", "size", "variant"];
import LoadingButton from "@mui/lab/LoadingButton";
export var MuiLoaderButton = function (props) {
    var _a = props.name, name = _a === void 0 ? "Button" : _a, _b = props.size, size = _b === void 0 ? "small" : _b, _c = props.variant, variant = _c === void 0 ? "outlined" : _c, other = _objectWithoutProperties(props, _excluded);
    return /*#__PURE__*/ React.createElement(LoadingButton, _extends({
        variant: variant,
        size: size,
        id: name
    }, other), name);
};
